import { Box, Tab, Tabs } from '@mui/material';
import { common } from '@mui/material/colors';
import { colors } from 'common/constants';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import General from './general';
import ServicePackage from './service-package';
import Discount from './discount';
import SurveyService from './survey-service';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

const tabsConfig = [
    {
        label: 'Cấu hình chung',
        path: '/admin/general-configuration',
        content: <General />,
    },
    {
        label: 'Cấu hình gói dịch vụ',
        path: '/admin/service-pack-configuration',
        content: <ServicePackage />,
    },
    {
        label: 'Cấu hình dịch vụ khảo sát',
        path: '/admin/survey-service-configuration',
        content: <SurveyService />,
    },
    {
        label: 'Cấu hình chiết khấu',
        path: '/admin/discount-configuration',
        content: <Discount />,
    },
];

const Configuration: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const currentTabIndex = tabsConfig.findIndex(
        (tab) => tab.path === location.pathname
    );
    const [value, setValue] = React.useState<number>(
        currentTabIndex !== -1 ? currentTabIndex : 0
    );

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        navigate(tabsConfig[newValue].path);
    };

    React.useEffect(() => {
        if (currentTabIndex !== value) {
            setValue(currentTabIndex !== -1 ? currentTabIndex : 0);
        }
    }, [location.pathname, currentTabIndex, value]);

    return (
        <Box sx={{ width: '100%' }}>
            <Box>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    centered
                    variant="fullWidth"
                    sx={{
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: '700',
                            fontSize: '24px',
                            padding: 2.5,
                            backgroundColor: common.white,
                            borderRadius: '15px',
                        },
                        '& .MuiTabs-flexContainer': {
                            justifyContent: 'space-between',
                            gap: 3,
                        },
                        '& .Mui-selected': {
                            backgroundColor: colors.main,
                            fontWeight: '700',
                            color: `${common.white} !important`,
                        },
                        '& .MuiTabs-indicator': {
                            display: 'none',
                        },
                    }}
                >
                    {tabsConfig.map((tab, index) => (
                        <Tab
                            key={index}
                            label={tab.label}
                            {...{
                                id: `simple-tab-${index}`,
                                'aria-controls': `simple-tabpanel-${index}`,
                            }}
                        />
                    ))}
                </Tabs>
            </Box>
            {tabsConfig.map((tab, index) => (
                <CustomTabPanel key={index} value={value} index={index}>
                    {tab.content}
                </CustomTabPanel>
            ))}
        </Box>
    );
};

export default Configuration;
